export function scrollIntoElement(
  id: string,
  childIndex?: number,
  isCenter?: boolean,
  includeHeader?: boolean
): void {
  const element = childIndex
    ? document.getElementById(id)?.children[childIndex]
    : document.getElementById(id)

  if (includeHeader) {
    const elRect = element?.getBoundingClientRect()

    if (elRect?.top) {
      window.scrollTo({
        top: window.scrollY + (elRect.top - 72), // 72 - высота шапки
        behavior: 'smooth',
      })
    }
  } else {
    element?.scrollIntoView({
      behavior: 'smooth',
      block: isCenter ? 'center' : 'start',
    })
  }
}
